import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, PropType, ref } from "vue";
import { useRouter } from "vue-router";
import { TirPmMultiselect, PopoverPositionType, TirPmSvg } from "tir-components";
import { ComponentInstance, debounce } from "tir-pm-toolkit";
import { QueueRelationModel } from "../../models";
import { ListBulletIcon } from "tir-style-system/icons/outline";
import TaskQueueSearchDropdownOption from "./task-queue-search-dropdown-option.vue";

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-queue-search-dropdown',
  props: {
  /**Отключить поповер */
  isDisabled: { type: Boolean, default: false },
  /**Кастомная позиция поповера */
  customPopoverPosition: { type: Object as PropType<PopoverPositionType> },
  /**Не телепортировать */
  noTeleport: { type: Boolean, default: false },
  /**Отключение потери фокуса при клике по контенту */
  disableContentBlur: { type: Boolean, default: false },
  /**Закрыть при выборе */
  closeBySelect: { type: Boolean, default: false },
  /**Функция поиска */
  searchFunction: { type: Function },
  /**ID очереди где расположена задача */
  taskQueueId: { type: String, required: true },
},
  emits: ["onSelect"],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();

/**Параметры */

/**События */


/**Поисковой запрос */
const search = ref("");
/**Список очередей */
const queues = ref<QueueRelationModel[]>([]);
/**Загрузка */
const isLoading = ref(false);
/**Кол-во очередей */
const queuesCount = ref();
/**Ссылка на компонента мультиселекта */
const $multiselect = ref<ComponentInstance<typeof TirPmMultiselect>>();

/**Запрос */
const pageRequest = computed(() => ({
  Search: search.value,
  Skip: queues.value.length,
  Take: 10,
}));
/**Id проекта */
const projectId = computed(() => Number(router.currentRoute.value.params.projectId));

const debounceOnSearch = debounce(() => searchQueues(true), 400);
/**Поиск очередей */
async function searchQueues(withResest?: boolean) {
  isLoading.value = true;
  if (withResest) {
    queues.value = [];
    pageRequest.value.Skip = 0;
  }
  if (
    queuesCount.value != undefined &&
    queuesCount.value !== 0 &&
    pageRequest.value.Skip >= queuesCount.value
  ) {
    isLoading.value = false;
    return;
  }

  const response = await props.searchFunction(projectId.value, pageRequest.value);

  if (response.IsSuccess) {
    queues.value.push(...response.Items);
    queuesCount.value = response.Count;
  }
  isLoading.value = false;
}
/**Проверить проскроллен ли элемент до конца */
const checkScrolledToBottom = (element: HTMLElement) => {
  return element.scrollTop + element.clientHeight + 100 >= element.scrollHeight;
};
/**При скролле */
const onScoll = (event: any) => {
  const target = event.target as HTMLElement | undefined;
  if (
    !target ||
    !checkScrolledToBottom(target) ||
    isLoading.value ||
    pageRequest.value.Skip >= queuesCount.value ||
    isLoading.value
  )
    return;

  searchQueues();
};
/**Обновление поиска */
const updateSearch = (_search: string) => {
  search.value = _search;
  debounceOnSearch();
};
/**Сброс значений переменных */
const resetData = () => {
  search.value = "";
  queues.value = [];
  queuesCount.value = undefined;
};
/**Выбор очереди */
const selectQueue = (_queue: QueueRelationModel) => {
  if (_queue.ParentTask) return;
  emit("onSelect", _queue);
  $multiselect.value?.close();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmMultiselect), {
    "no-teleport": "",
    "disable-content-blur": "",
    "search-input-autofocus": "",
    staticScrollHeight: "",
    class: "task-queue-search-dropdown",
    ref_key: "$multiselect",
    ref: $multiselect,
    "search-input-label": "Поиск по очереди или рабочей области",
    "popover-width": "32.5rem",
    "is-search-local": false,
    isDisabled: __props.isDisabled,
    options: queues.value,
    "popover-position": __props.customPopoverPosition,
    "show-on-hover": "",
    onOnScroll: onScoll,
    onUpdateSearch: updateSearch,
    onEnter: searchQueues,
    onOnOpen: searchQueues,
    onOnClose: resetData
  }, {
    target: _withCtx(() => [
      _renderSlot(_ctx.$slots, "target")
    ]),
    optionList: _withCtx(({ option }) => [
      _createVNode(TaskQueueSearchDropdownOption, {
        queue: option,
        "is-current-queue": __props.taskQueueId === option.Id,
        onSelect: ($event: any) => (selectQueue(option))
      }, null, 8, ["queue", "is-current-queue", "onSelect"])
    ]),
    _: 3
  }, 8, ["isDisabled", "options", "popover-position"]))
}
}

})